module.exports = __webpack_public_path__ + "media/images/universe_landing_pages/hero_banner/component/haircut-desktop-0bc2d77d60dc8fd24fcc1620a11621dc.jpg";